<template>
  <div class="content-box">
    <div class="big-error-w">
      <h1>Ooopss...</h1>
      <h5>Ha ocurrido un error con la conexión</h5>
      <h4>Comunicate con el departamento de sistema a <a href="sistemas@tdoriente.com">sistemas@tdoriente.com</a></h4>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
  },
  mounted() {
  },
  methods: {
  }
};
</script>
